import styled from "styled-components";
/**
 * Each `FormFieldGroup` in a `FormRepeatedGroup` usually has two parts -
 * the form field components, and the controls for the repeated group.
 *
 * The ComponentContainer styles the form field components correctly within
 * the repeated group.
 */
export const ComponentContainer = styled.div `
  flex: 1;
`;
